import Crud from '../views/Pergunta/Crud'
import Entity from '../views/Pergunta/Add'
import View from '../views/Pergunta/View'

let routes = {
    path: '/perguntas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/perguntas/add',
            name: 'NewPergunta',
            component: Entity
        },
        {
            path: '/perguntas/edit/:id?',
            name: 'EditPergunta',
            component: Entity
        },
        {
            path: '/perguntas/view/:id?',
            name: 'ViewPesquisa',
            component: View
        },
        {
            path: '/perguntas',
            name: 'list-perguntas',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Perguntas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
